const Card = ({ icon, title, onClick }) => (
    <div className="flex flex-col items-center justify-center p-5 bg-white rounded-lg shadow-md hover:bg-gray-200 h-40 cursor-pointer"
    onClick={onClick}>
      <img src={icon} alt="icon" className="mb-3 w-20 h-20" />
      <div className="text-lg font-semibold">{title}</div>
    </div>
  );

export default Card;